import { AuthorizedPage } from '@maxtropy/components';
import { FC, ReactNode } from 'react';

const SelectStaffLayout: FC<{ children?: ReactNode }> = ({ children }) => {
  return <AuthorizedPage>{children}</AuthorizedPage>;
};

export default SelectStaffLayout;
